import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoldPrice from '../components/GoldPrice';
import Currency from '../components/Currency';

export default function MobileGoldCurrencyScreen() {
  const navigate = useNavigate();

  return (
    <div className="p-4 bg-white min-h-screen">
      <button
        onClick={() => navigate('/utilities')}
        className="mb-4 text-vietnam-primary hover:underline"
      >
        ← Quay lại
      </button>

      <div className="mb-4">
        <GoldPrice />
      </div>

      <Currency />
    </div>
  );
}
